module.exports = __webpack_public_path__ + "static/media/btn_point_back_pre.af22cf65.svg";